export default "__VITE_ASSET__62f153a1__"